import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	enable: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	description: {
		id: 'service-management-hr-expansion-experiment-spotlight.description',
		defaultMessage:
			'Set up your new project fast using the HR service management template, or <a>read about service management for HR.</a>',
		description: 'The HR expansion experiment spotlight content description',
	},
	descriptionGalaxia: {
		id: 'service-management-hr-expansion-experiment-spotlight.description-galaxia',
		defaultMessage:
			'Set up your new space fast using the HR service management template, or <a>read about service management for HR.</a>',
		description: 'The HR expansion experiment spotlight content description',
	},
	heading: {
		id: 'service-management-hr-expansion-experiment-spotlight.heading',
		defaultMessage: 'Want to deliver better HR service experiences from day one?',
		description: 'The HR expansion experiment spotlight heading',
	},
	enable: {
		id: 'service-management-hr-expansion-experiment-spotlight.enable',
		defaultMessage: 'Try now',
		description: 'Try now button the spotlight',
	},
	dismiss: {
		id: 'service-management-hr-expansion-experiment-spotlight.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button on the spotlight',
	},
});
export default messages;
